"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../style/index.less");
require("./index.less");
// style dependencies
// deps-lint-skip: menu
// deps-lint-skip: grid
require("../../button/style");
require("../../radio/style");
require("../../checkbox/style");
require("../../tooltip/style");
require("../../empty/style");
require("../../dropdown/style");
require("../../spin/style");
require("../../_components/_pagination/style");
//# sourceMappingURL=index.js.map